import React from "react";
import Content from "../components/Content/Content";
import Education from "../components/Education/Education";
import Intro from "../components/Intro/Intro";
import Skills from "../components/Skills/Skills";

const Homepage = () => {
  return (
    <>
      <Intro />
      <Skills />
      <Education />
      <Content />
    </>
  );
};

export default Homepage;
